(function() {
    'use strict';
    angular
        .module('womenCellApp')
        .factory('Suggestion', Suggestion);

    Suggestion.$inject = ['$resource', 'DateUtils'];

    function Suggestion ($resource, DateUtils) {
        var resourceUrl =  'api/suggestions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.suggestionDate = DateUtils.convertDateTimeFromServer(data.suggestionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
